<template>
  <div>
    <van-swipe :autoplay="3000" :height="swipeHeight" class="banner">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img :src="image" />
      </van-swipe-item>
    </van-swipe>
    <div :class="{'body-box': true, 'body-box-light': defaultTheme == 'light' }" :style="`height: ${bodyHeight}px; top: ${swipeHeight}px`">
      <div class="cont-box pt20 pm15 ml10 mr10 bgbs">
        <div class="ground-tit row pm20 fz18">
          <div class="ground-tit-line"></div>
          <div>请选择参观区域</div>
          <div class="ground-tit-line ground-tit-line-right"></div>
        </div>
        <div class="ground-item pt5 pr10 pm5 pl10" @click="onShowBuyNotice">
          <img class="ground-pic" src="@/assets/img/ground1.jpg" :style="{width: groundWidth + 'px'}" />
          <div class="ground-name cen fz15">叶挺纪念馆景区</div>
          <div class="ground-name cen fz12">(含叶挺生平事迹展主题展馆、叶挺故居、腾云学堂、育英楼等附属景点)</div>
          <!-- (含叶挺生平事迹展主题展馆、叶挺故居、腾云学堂、育英楼等附属景点) -->
        </div>
        <div class="ground-item pt5 pr10 pm5 pl10" @click="toTicketBuy">
          <img class="ground-pic" src="@/assets/img/exhibit1.jpg" :style="{width: groundWidth + 'px'}" />
          <div class="ground-name cen fz15">香港秘密大营救在惠阳陈列馆</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scenicImage1 from "./../assets/img/banner.jpg";

export default {
  name: "home",
  data() {
    return {
      defaultTheme: window.defaultTheme,
      images: [scenicImage1],
      swipeHeight: 160,
      bodyHeight: 450,
      groundWidth: 335,
      buyTicketEnable: window.buyTicketEnable
    };
  },
  created() {
    console.log(this.$router.query)
  },
  methods: {
    async onShowBuyNotice() {
      // this.$router.push("notice");
      this.$router.push({
        name: "notice",
        params: { exhibitionHall: "YeTing" },
      });
    },
    toTicketBuy() {
      if (!this.buyTicketEnable) {
        this.$toast("暂未开放，敬请期待！");
        return;
      }
      this.$router.push({
        name: "notice",
        params: { exhibitionHall: "SecretRescue" },
      });
      // this.$router.push({
      //   name: "buyticket",
      //   params: { publicSaleFlag: "true" },
      // });
    },
    resize() {
      const clientW = document.documentElement.clientWidth;
      const widthRatio = clientW / 750;
      this.swipeHeight = widthRatio * 320;
      this.bodyHeight = document.documentElement.clientHeight - this.swipeHeight - 40;
      this.groundWidth = clientW - 40;
    }
  },
  mounted() {
    this.resize();
    let vm = this;
    window.onresize = function () {
      vm.resize();
    };
  }
};
</script>

<style lang="scss" scoped>
.banner {
  img {
    width: 100%;
    height: 100%;
  }
  /deep/ .van-swipe__indicators {
    bottom: 32px;
  }
}
.body-box {
  width: 100%;
  position: absolute;
  background: url("../assets/img/indexbg.jpg") no-repeat #f2e9d7;
  background-size: cover;
  .cont-box {
    margin-top: -20px;
    border-radius: 6px;
    flex: 1;
    .ground-tit {
      justify-items: center;
      justify-content: center;
      .ground-tit-line {
        margin: 13px 15px 12px;
        width: 40px;
        height: 1px;
        background: linear-gradient(to right, #fff, #6a4240);
      }
      .ground-tit-line-right {
        background: linear-gradient(to right, #6a4240, #fff);
      }
    }
    .ground-item {
      .ground-pic {
        border-radius: 6px;
      }
      .ground-name {
        padding: 2px;
      }
    }
  }
}
</style>
